export const enum FormPropertyShareStatechartActionEnum {
  /**
   * Set submitting status (show loader)
   */
  setSubmittingStatus = 'setSubmittingStatus',

  /**
   * Execute google captcha
   */
  executeCaptcha = 'executeCaptcha',

  /**
   * Reset submitting status (hide loader)
   */
  resetSubmittingStatus = 'resetSubmittingStatus',

  /**
   * Send submit request to server
   */
  sendSubmitRequest = 'sendSubmitRequest',

  /**
   * Validate user input
   */
  validateInput = 'validateInput',

  /**
   * Show server errors
   */
  showErrors = 'showErrors',

  /**
   * Set submitted status (show success message)
   */
  setSubmittedStatus = 'setSubmittedStatus',

  /**
   * Cache property share model for form fields pre population
   */
  cacheModel = 'cacheModel',
}
